import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'

import { TtIconButton } from '@23/react'

import './SelectionItemComponent.scss'

class SelectionItemComponent extends React.Component {
  constructor(props) {
    super(props)

    this.renderObjectType = this.renderObjectType.bind(this)
    this.renderThumbnail = this.renderThumbnail.bind(this)
  }

  renderObjectType() {
    const { item } = this.props
    switch (item.object_type) {
      case 'photo':
        return (
          <div className="selection-item-type">
            <FormattedMessage defaultMessage="Video" />
          </div>
        )
      case 'live':
        return (
          <div className="selection-item-type">
            <FormattedMessage defaultMessage="Live event" />
          </div>
        )
      case 'album':
        return (
          <div className="selection-item-type">
            <FormattedMessage defaultMessage="Category" />
          </div>
        )
      default:
        return null
    }
  }

  renderThumbnail() {
    const { item } = this.props
    if (/photo|live/.test(item.object_type)) {
      const id = item.photo_id || item.live_id || item.object_id
      const { token } = item
      const url = `/thumbnail/${id}/${token}/60x40cr/`

      return (
        <img
          className="selection-item-thumbnail"
          src={url}
          alt={intl.formatMessage({ defaultMessage: 'Selection Thumbnail' })}
        />
      )
    }
    return null
  }

  render() {
    const { item, theme, renderExtraButtons, onClick, className, toggleItem } =
      this.props
    const title = item.title || item.name

    const deselectAriaLabel = intl.formatMessage(
      {
        defaultMessage: 'Deselect video with the following title: {videoName}',
      },
      { videoName: title }
    )
    return (
      <div
        className={`selection-item-component selection-item-${item.object_type} theme-${theme} ${className}`}
        onClick={onClick}
      >
        <div className="selection-item-inner">
          <div>{this.renderThumbnail()}</div>
          <div>
            <div className="selection-item-title">{title}</div>
            {this.renderObjectType()}
          </div>
        </div>
        <div className="buttons">
          {renderExtraButtons && renderExtraButtons()}
          <TtIconButton
            className="selection-item-deselect"
            name="close"
            library="one"
            label={deselectAriaLabel}
            onClick={() => {
              toggleItem(item)
            }}
          />
        </div>
      </div>
    )
  }
}

SelectionItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
  toggleItem: PropTypes.func.isRequired,
  renderExtraButtons: PropTypes.func,
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(['light', 'dark', 'webinar']),
  className: PropTypes.string,
}

SelectionItemComponent.defaultProps = {
  theme: 'light',
  className: '',
}

export default SelectionItemComponent
